import api from "../api";

const controller = '/naoConformidadeCaixaDeEntrada';

export interface CaixaEntradaProps {
  infoComplementar: string;
  link: string;
  id: string;
  processo: string;
  atividade: string;
  projeto: string;
  responsavel: string;
  naoConformidadeId?: string;
  solicitacaoNaoPrevistoId: string
  solicitante: string
}

export const CaixaEntradaProcessos = []



export const GetAllCaixaEntradaPendenciaValidacao = async () => {
  return await api.get<Array<CaixaEntradaProps>>(`${controller}/GetAllPendenciaValidacao`);
}
export const GetAllCaixaEntradaPendenciaNaoValidacao = async () => {
  return await api.get<Array<CaixaEntradaProps>>(`${controller}/GetAllPendenciaNaoValidacao`);
}

export const GetAllCaixaEntradaPendenciaAprovacao = async () => {
  return await api.get<Array<CaixaEntradaProps>>(`${controller}/GetAllPendenciaAprovacao`);
}

export const GetAllCaixaEntradaPendenciaReprovacao = async () => {
  return await api.get<Array<CaixaEntradaProps>>(`${controller}/GetAllPendenciaReprovacao`);
}

export const GetAllCaixaEntrada = async () => {
  return await api.get<Array<CaixaEntradaProps>>(`${controller}/GetAll`);
}